module.exports = __webpack_public_path__ + "static/demogorgon-8d1a9ca33d55afc0378a64d0a76f2861.jpg";